import React from 'react';
import { useLocation } from 'react-router-dom';
import { GiEarthWorm } from 'react-icons/gi';
import ParasitologiaDoseResponseForm from '../components/ParasitologiaDoseResponseForm';

const ParasitologiaDoseResponsePage = () => {
  const location = useLocation();
  const protocoloGeneralInicial = location.state?.protocoloGeneral || '';
  const protocoloMuestraInicial = location.state?.protocoloMuestra || '';
  const returnToCaseDetail = Boolean(location.state?.returnToCaseDetail);

  return (
    <section className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">Sector</span>
          <h2 className="page-title">{'Parasitolog\u00eda'}</h2>
          <p className="page-subtitle">
            {'Procesa archivos TXT de dosis-respuesta, revisa el ajuste y guarda un resultado con informe y gr\u00e1ficos adjuntos.'}
          </p>
        </div>
        <div className="molecular-page-badge" aria-hidden="true">
          <GiEarthWorm />
        </div>
      </div>

      <ParasitologiaDoseResponseForm
        protocoloGeneralInicial={protocoloGeneralInicial}
        protocoloMuestraInicial={protocoloMuestraInicial}
        returnToCaseDetail={returnToCaseDetail}
      />
    </section>
  );
};

export default ParasitologiaDoseResponsePage;
